import { Component, defineComponent } from '@decify/cell-shopify/client';
import { productOptionSelectorChangeEvent, productOptionSelectorName, } from '../ProductOptionSelector';
import './ProductCard.scss';
export const productCardName = 'ProductCard';
export const productCardTagName = 'cell-component-product-card';
export class ProductCard extends Component {
    activeImageType;
    constructor() {
        super(productCardName);
        this.activeImageType = 'primary';
        this.handleProductOptionChange = this.handleProductOptionChange.bind(this);
    }
    componentDidMount() {
        this.subscribe(`${productOptionSelectorName}.${productOptionSelectorChangeEvent}`, this.handleProductOptionChange);
    }
    handleProductOptionChange(data) {
        this.showColorImage(data.value);
    }
    toggleImage() {
        if (!this.secondaryImage.element)
            return;
        this.colorImages.forEach((image) => image.element.setAttribute('hidden', ''));
        if (this.activeImageType === 'primary') {
            this.activeImageType = 'secondary';
            this.primaryImage.element.setAttribute('hidden', '');
            this.secondaryImage.element.removeAttribute('hidden');
        }
        else {
            this.activeImageType = 'primary';
            this.primaryImage.element.removeAttribute('hidden');
            this.secondaryImage.element.setAttribute('hidden', '');
        }
    }
    showColorImage(color) {
        const colorImage = this.colorImages.find((image) => image.element.getAttribute('data-color') === color);
        if (!colorImage)
            return;
        this.primaryImage.element.setAttribute('hidden', '');
        this.secondaryImage.element?.setAttribute('hidden', '');
        this.colorImages.forEach((image) => image.element.setAttribute('hidden', ''));
        colorImage.element.removeAttribute('hidden');
    }
    get images() {
        const primaryImage = this.querySelector('.ProductCard__Image');
        if (!primaryImage) {
            throw new Error('Primary image not found');
        }
        return [
            {
                type: 'primary',
                element: primaryImage,
            },
            {
                type: 'secondary',
                element: this.querySelector('.ProductCard__Image--Secondary'),
            },
            ...[...this.querySelectorAll('.ProductCard__Image--Color')].map((imageElement) => ({
                type: 'color',
                element: imageElement,
            })),
        ];
    }
    get primaryImage() {
        return this.images.find((image) => image.type === 'primary');
    }
    get secondaryImage() {
        return this.images.find((image) => image.type === 'secondary');
    }
    get colorImages() {
        return this.images.filter((image) => image.type === 'color');
    }
}
defineComponent(productCardTagName, ProductCard);
